/** Public audio URLs (CDN hashes remapped). */
export const CLUB_TRACK = `/audio/its-like-that.mp3`;
export const FOREST_TRACK = `/audio/forest-night.mp3`;
export const ge = CLUB_TRACK;
export const _e = FOREST_TRACK;
